/**
 * Typed narration keys. Each key has one OGG per locale in
 * `public/audio/voice/{locale}/{key-with-dashes}.mp3` and its source text
 * in `scripts.ts` (which the TTS batch uses to generate the audio).
 */

export const NARRATION_LOCALES = ["en", "es", "pt", "fr", "de", "it"] as const;
export type NarrationLocale = (typeof NARRATION_LOCALES)[number];

export const NARRATION_KEYS = [
  // Numbers (Count and Play)
  "num.1",
  "num.2",
  "num.3",
  "num.4",
  "num.5",
  "num.6",
  "num.7",
  "num.8",
  "num.9",
  "num.10",
  // Vocabulary (Who Sounds?)
  "instrument.piano",
  "instrument.xylophone",
  "instrument.drums",
  "sound.bell",
  "sound.wood",
  "sound.magic",
  // Celebrations and guidance
  "praise.great",
  "praise.wow",
  "praise.well-done",
  "guide.your-turn",
  "guide.listen",
] as const;

export type NarrationKey = (typeof NARRATION_KEYS)[number];

/** Narration key for a number 1-10, without type assertions. */
export function numberKey(n: number): NarrationKey | undefined {
  return NARRATION_KEYS.find((key) => key === `num.${n}`);
}

/** Audio filename for a key (dots → dashes). */
export function narrationFile(key: NarrationKey): string {
  return `${key.replaceAll(".", "-")}.mp3`;
}
